'use client'
import { FC } from 'react'
import Link from 'next/link'
import { Icon } from '@/icons'
import { widgetStore } from '@/domains/WebApp/store/Widget'
import { SITE_DOMAINS } from '@/config'

interface LogoLinkProps {
  className?: string
}
export const LogoLink: FC<LogoLinkProps> = ({ className }) => {
  return (
    <Link
      href={
        widgetStore.isWidget && SITE_DOMAINS[0] != null ? SITE_DOMAINS[0] : '/'
      }
    >
      <Icon name="logo" />
    </Link>
  )
}
